import * as React from 'react';

import * as style from './RowTitleField.css';

export const RowTitleField: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
